module.exports = __webpack_public_path__ + "img/logo-column.e40ce137.png";